import { Field, Formik, Form } from "formik";
import React, { useState } from "react";
import { Form as BForm, Col, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import TextInput from "../../../../components/formfields/InputField";
import CustomButton from "../../../../components/Buttons/CustomButton";
import { addVideo } from "./redux/action";

function AddVideoModal({
  show,
  setShow,
  editVideo,
  setEditVideo,
}: {
  show: boolean;
  setShow: (value: boolean) => void;
  editVideo: any;
  setEditVideo: (value: any) => void;
}) {
  const handleClose = () => setShow(false);
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const initialState = {
    id: editVideo?.id || "",
    title: editVideo?.title || "",
    url: editVideo?.url || "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Please enter title"),
    url: Yup.string()
      .required("Please enter URL")
      .matches(
        // eslint-disable-next-line no-useless-escape
        /^(https?:\/\/)?(www\.)?(youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})(\?[^\s]*)?$/,
        "Invalid YouTube URL",
      ),
  });

  const handleSubmit = (values: any) => {
    setLoader(true);
    dispatch(
      addVideo(values, () => {
        setLoader(false);
        handleClose();
        setEditVideo(null);
      }),
    );
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Formik enableReinitialize initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
        <Form>
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold h6">{editVideo ? "Edit Video" : "Add Video"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="gy-3">
              <Col xs={12}>
                <BForm.Label>Video Title</BForm.Label>
                <Field name="title" component={TextInput} placeholder="Enter Title" className="editField" />
              </Col>
              <Col xs={12}>
                <BForm.Label>Youtube URL</BForm.Label>
                <Field name="url" component={TextInput} placeholder="Enter URL" className="editField" />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <CustomButton type="button" variant="blue" onClick={handleClose}>
              Cancel
            </CustomButton>
            <CustomButton type="submit" variant="success" disabled={loader}>
              {editVideo ? "Update" : "Add"}
              {loader && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true" />}
            </CustomButton>
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal>
  );
}

export default AddVideoModal;
